import React, { useCallback, useState } from 'react';
import style from './style';
import { Grid } from '@mui/material';
import EAAccordion from 'components/EAAccordion';
import i18next from 'i18next';
import EAIcon from 'components/common/EAIcon';
import EAButton from 'components/common/EAButton';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import EADialog from '../../../../../../components/common/EADialog';
import AttributeForm from '../../../../attributes/AttributeForm';
import { ContextBondTypes } from '../../../../../../services/common/Constants';
import EAColorIcon from '../../../../../../components/common/EAColorIcon';

const Attribut = ({ title, attributContextType, dialogTitle, readOnly = false }) => {
  const { classes } = style();
  const [openCreateContextAttribute, setOpenCreateContextAttribute] = useState(
    false
  );
  const [editedAttribute, setEditedAttribute] = useState();
  const formId = attributContextType;

  const bondType = (() => {
    switch (attributContextType) {
      case 'contextAttributes':
        return ContextBondTypes.CONTEXT;
      case 'tiersAttributes':
        return ContextBondTypes.CONTEXT_THIRD_PARTY;
      case 'demandeAttributes':
        return ContextBondTypes.CONTEXT_THIRD_PARTY_DEMAND;
      default:
        return null;
    }
  })();

  const { control, getValues } = useFormContext();

  const {
    append: appendContextAttribute,
    remove: removeContextAttribute,
    update: updateAttribute,
  } = useFieldArray({
    control,
    name: attributContextType,
    keyName: 'fieldArrayId',
  });

  const closeContextAttribute = useCallback(() => {
    setOpenCreateContextAttribute(false);
  }, []);

  const currentContextAttributes = useWatch({
    control,
    name: attributContextType,
  });

  const onCreateAttribute = () => {
    setEditedAttribute(null);
    setOpenCreateContextAttribute(true);
  };

  const addAttribute = (attribute) => {
    appendContextAttribute(attribute);
    setOpenCreateContextAttribute(false);
  };

  const editAttribute = useCallback(
    (attribute) => {
      const attributes = getValues(attributContextType);
      const index = attributes.findIndex(
        (att) => att.label === editedAttribute.label
      );
      if (index !== -1) {
        updateAttribute(index, attribute);
      }
      setOpenCreateContextAttribute(false);
    },
    [editedAttribute, updateAttribute, getValues, attributContextType]
  );

  const onEditAttribute = (attribute) => {
    setEditedAttribute(attribute);
    setOpenCreateContextAttribute(true);
  };

  return (
    <Grid item xs={12} className={classes.root}>
      <EAAccordion title={title} titleNoResult={true} opened={true}>
        <div className={classes.contentContainer}>
          {currentContextAttributes.length ? (
            <div>
              <div className={classes.content}>
                {currentContextAttributes.map((att, i) => {
                  return (
                    <>
                      {att.label ? (
                        <div className={classes.attributWrapper}>
                          <div
                            className={classes.attributInfos}
                            onClick={() => !readOnly && onEditAttribute(att)}
                          >
                            <div className={classes.attributLibelle}>
                              {att.label}
                            </div>
                            <div className={classes.attributType}>
                              {i18next.t(`attributeType.${att.type}`)}
                            </div>
                          </div>
                          {!readOnly &&
                            <EAIcon
                              className={classes.deleteAttributButton}
                              icon={'delete_red'}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                removeContextAttribute(i);
                              }}
                            />
                          }
                        </div>
                      ) : (
                        ''
                      )}
                    </>
                  );
                })}
              </div>
              {!readOnly &&
                <EAButton
                  className={classes.addAttribute}
                  icon={'add'}
                  onClick={(e) => {
                    e.preventDefault();
                    onCreateAttribute();
                  }}
                  content={i18next.t(
                    'demandes.contextModel.creationForm.attributs.ajouterAttributs'
                  )}
                />
              }
            </div>
          ) : !readOnly && (
            <div
              onClick={() => onCreateAttribute()}
              className={classes.emptyContent}
            >
              <EAColorIcon icon={'add'} />
              <div className={classes.emptyContentTitle}>
                {i18next.t(
                  'demandes.contextModel.creationForm.attributs.ajouterAttributs'
                )}
              </div>
            </div>
          )}
        </div>
      </EAAccordion>
      <EADialog
        formId={formId}
        isOpen={openCreateContextAttribute}
        title={dialogTitle}
        onCancel={closeContextAttribute}
        onClose={closeContextAttribute}
        maxWidth={'popupmd'}
        fullWidth
        hasActions={true}
        displayBtn={true}
        variant={'rightControl'}
      >
        {openCreateContextAttribute && (
          <AttributeForm
            setIsValidateDisabled={() => {}}
            submitHandler={editedAttribute ? editAttribute : addAttribute}
            bondType={bondType}
            formId={formId}
            formType={editedAttribute ? 'edit' : 'create'}
            attribute={editedAttribute ? editedAttribute : null}
          />
        )}
      </EADialog>
    </Grid>
  );
};

export default Attribut;
